import { useTranslation } from "react-i18next";
import SectionHeader from "../../../../../util/component/SectionHeader";
import * as React from "react";
import CreatePrintout from '../sections/CreatePrintout';

const PrintoutWizard = () => {

    const { t } = useTranslation('finance', { keyPrefix: 'mobility-store' });

    return (
            <>
                <SectionHeader title={t('printout-wizard.header.title')} subtitle={t('printout-wizard.header.subtitle')}/>
                <CreatePrintout/>
            </>
    );
}

export default PrintoutWizard;